exports.install = function (Vue, options) {
	Vue.prototype.api.Tactics = {
		doAeratorDevices(value={})//获取溶氧设备或增氧设备
		{
			if(value.qaedasId==null)
			{
				value.qaedasId = Vue.prototype.getCookie(Vue.prototype.config.jdid);
			}
			return Vue.prototype.axiosget("/api/Tactics/doAeratorDevices",value)
			.then((response)=>{
				return response;
			});
		},
		getList(value={})//获取溶氧策略列表数据
		{
			if(value.qaedasId==null)
			{
				value.qaedasId = Vue.prototype.getCookie(Vue.prototype.config.jdid);
			}
			return Vue.prototype.axiosget("/api/Tactics/getList",value)
			.then((response)=>{
				return response;
			});
		},
		add(value={})//添加溶氧策略
		{
			if(value.qaedasId==null)
			{
				value.qaedasId = Vue.prototype.getCookie(Vue.prototype.config.jdid);
			}
			return Vue.prototype.axiospost("/api/Tactics/add",value)
			.then((response)=>{
				return response;
			});
		},
		delete(value)//删除溶氧策略
		{
			return Vue.prototype.axiospost("/api/Tactics/delete",value)
			.then((response)=>{
				return response;
			});
		}
	};
}
